import React from "react";
import LoaderIcon from "Components/loader/LoaderIcon";

import cx from "classnames";
import s from "./loader.scss";

export default class Loader extends React.Component {
  render() {
    let { className, iconSize, msg, inLine } = this.props;
    return (
      <div className={cx(className, s.loader, { [s.inLine]: inLine })}>
        <div className={s.wrapLoader}>
          <LoaderIcon iconSize={iconSize ? iconSize : "4rem"} />
          <div className={s.msg}>{msg}</div>
        </div>
      </div>
    );
  }
}
